import axios from "axios";
export const VerifyCodeAndFetchBankDetails = {
  data: () => ({}),
  methods: {
    async VerifyCodeAndFetchBankDetailsMethod(user_email_id, otp, bank_id) {
      try {
        let data = JSON.stringify({
          command: "verifyOTPAndGetBankDetails",
          user_email_id,
          otp,
          bank_id,
        });
        let config = {
          method: "post",
          maxBodyLength: Infinity,
          url: this.getDynamicVerifyCodeAndFetchBankDetailsRestAPIUrlMethod(),
          headers: {
            "Content-Type": "application/json",

            "x-api-key": this.getDynamic5RestAPIKeyMethod(),
          },
          data: data,
        };

        let result = await axios(config);
        return result;
      } catch (error) {
        return {
          status: error.response.status,
          statusText: "FAILURE",
          error: error.response.data.Model,
        };
      }
    },
    getDynamicVerifyCodeAndFetchBankDetailsRestAPIUrlMethod() {
      return window.location.hostname === "dev.commdealdata.com" || window.location.hostname === "www.dev.commdealdata.com" || window.location.hostname == "localhost"
        ? "https://auqtxhrtrl.execute-api.us-east-1.amazonaws.com/dv/verifyotpandfetchbank"
        // ? "https://7mw4ny54cc.execute-api.us-east-1.amazonaws.com/dev/verifyotpandfetchbank" - old dev
        : window.location.hostname === "test.commdealdata.com" || window.location.hostname === "www.test.commdealdata.com"
        ? "https://iepve9v0rg.execute-api.us-east-1.amazonaws.com/qa/verifyotpandfetchbank"
        // ? "https://a9fb1td1g1.execute-api.us-east-1.amazonaws.com/test/verifyotpandfetchbank" - old test
        : window.location.hostname === "uat.commdealdata.com" || window.location.hostname === "www.uat.commdealdata.com"
        ? "https://d1f7r2w2n1.execute-api.us-east-1.amazonaws.com/uat/verifyotpandfetchbank"
        : "https://401a68okke.execute-api.us-east-1.amazonaws.com/live/verifyotpandfetchbank";
    },
    getDynamic5RestAPIKeyMethod() {
      return window.location.hostname === "dev.commdealdata.com" || window.location.hostname === "www.dev.commdealdata.com" || window.location.hostname == "localhost"
        ? "SXUET0qbEx2hrUogtD4nHWh4BlLtvUi9W2MHiKBg" // "Df77h95pAo76hNjGGxjQTaYEiaN0CR2z179805yW" - old key
        : window.location.hostname === "test.commdealdata.com" || window.location.hostname === "www.test.commdealdata.com"
        ? "O7vlIPISux2w3CrqIk69A6Dwz0Wd1Rsw3UrYJiR4" // "xSGhbOtd6g2DYh5PhhOJ77HPFFYAQziDCst97SZ7" - old test
        : window.location.hostname === "uat.commdealdata.com" || window.location.hostname === "www.uat.commdealdata.com"
        ? "iORDwCSXHl670CUuvVuo10kvpylJw7I7KdBqatWc"
        : "w6QQeRLHshapYVbYT94aX9TCJCl75pc37oW3BrOb";
    },
  },
};
